import { createContext } from 'react'
import LengthOfTimeEntry from '../../../LengthOfTime/LengthOfTimeEntry'
import { EmployerDetailsEntry, EmploymentHistoryEntry } from '../EmploymentHistoryContext'

export type EmploymentHistoryEntryAction =
  { type: 'PREVIOUS' } |
  { type: 'NEXT' } |
  { type: 'EDIT', value: string } |
  { type: 'UPDATE_STATUS', value: string } |
  { type: 'UPDATE_TIME_IN_SITUATION', value: LengthOfTimeEntry } |
  { type: 'UPDATE_EMPLOYER_DETAILS', value: EmployerDetailsEntry }

interface ContextProps {
  dispatch: ((action: EmploymentHistoryEntryAction) => void)
}

const EmploymentHistoryEntryContext = createContext<ContextProps>({
  dispatch: () => { }
})

export type EmploymentSubQuestion = 'SITUATION' | 'EMPLOYER_DETAILS' | 'TIME_IN_SITUATION' | 'EMPLOYMENT_QUESTIONS_GROUPED'

export interface EmploymentHistoryEntryState {
  entry: EmploymentHistoryEntry
  escapeAction?: 'PREVIOUS' | 'NEXT'
  question: EmploymentSubQuestion
}

export default EmploymentHistoryEntryContext
